import styles from '../../../MultiStepPMSLogin.module.scss'
import sampleEmail from './sampleEmail.png'

const KindOfEmail = () => {
  return (
    <div className={styles.solutionContainer}>
      <p className={styles.descriptionTextEmp}>
        After sending email provided in the first step, you should receive an email like
        below.
      </p>
      <img src={sampleEmail} alt="sampleEmail" width={'500px'} />
    </div>
  )
}

export default KindOfEmail
